import React from 'react';
import styled from 'styled-components';
import { EditIcon, BackIcon } from './icon-components';
const CARD_HEIGHT = '180px';

const Card = styled.div`
  background-color: ${(props) => props.isHovered ? 'rgba(0, 0, 0, 0.20000000298023224)' : '#fff'};
  border-radius: 8px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.15);
  width: 100%;
  height: ${(props) => props.height ? `${props.height}` : CARD_HEIGHT};
  position: relative;
  padding: 20px;
  .feedback-card {
    height: 100%;
    position: relative;
    &__info {
      &__name {
        color: #333333;
        font-family: Muli;
        font-size: 18px;
        line-height: 22px;
        padding-bottom: 10px;
      }
      &__coquan {
        color: #19B1F8;
        font-family: Muli;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 10px;
      }
    }
    &__description {

    }
    &__time {
      position: absolute;
      bottom: 0px;
      color: #9B9B9B;
      font-family: Muli;
      font-size: 14px;
      line-height: 17px;
      text-align: left;
    }
  }
  .staff-card {
    display: flex;
    align-items: center;
    justify-content: space-around;
    &__image {
      img {
        height: 100px;
        border-radius: 50%;
      }
    }
    &__info {
      &__name {
        color: #333333;
        font-family: Muli;
        font-size: 18px;
        line-height: 22px;
        padding-bottom: 10px;
      }
      &__coquan {
        color: #19B1F8;
        font-family: Muli;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 10px;
      }
      &__phong {
        color: #9B9B9B;
        font-family: Muli;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 10px;
      }
    }
  }
  hr {
    border: none;
    border-top: solid 1px #F0F0F0;
    margin: 13px 0px;
  }
`;

export const Hr = styled.hr`
  border: none;
  border-top: solid 1px #F0F0F0;
  margin: 13px 0px;
`;

const EditButtonWrapper = styled.div`
  margin: 5px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background: #E0E0E0;
  }
`;

const BackButtonIconWrapper = styled.div`
  margin: 5px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background: #E0E0E0;
  }
`;

export const EditButtonIcon = () => {
  return (
    <EditButtonWrapper>
      <EditIcon />
    </EditButtonWrapper>
  )
}

export const InputWrapper = styled.div`
  .ant-input-number {
    width: 100%;
  }
`;

export const BackButtonIcon = (props) => {
  return (
    <BackButtonIconWrapper onClick={props.onClick}>
      <BackIcon />
    </BackButtonIconWrapper>
  )
}
export default Card